import type { App } from "@upsquad/server";
import type { LegalKind } from "@upsquad/shared";
import type { EdenCall } from "@/src/common/lib/eden-base-query";
import { baseApi } from "@/src/common/services/base-api";

type GetPublicCommunityLegalResponse = App["~Routes"]["community-mobile-app"]["public"][":slug"][":kind"]["get"]["response"]["200"];

export const legalApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getPublicCommunityLegal: builder.query<GetPublicCommunityLegalResponse, { slug: string; kind: LegalKind }>({
			query:
				({ slug, kind }): EdenCall<GetPublicCommunityLegalResponse> =>
				(client) =>
					client["community-mobile-app"].public({ slug })({ kind }).get(),
		}),
	}),
});

export const { useGetPublicCommunityLegalQuery } = legalApi;
